import React from 'react';

const ValentineMessage: React.FC = () => {
  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 pointer-events-none">
      <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl px-12 py-8 border-4 border-pink-400">
        <h1 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-red-500 text-center mb-2">
          To my valentine,
        </h1>
        <h2 className="text-4xl font-semibold text-pink-600 text-center">
          Happy Valentine's Day
        </h2>
        <div className="text-6xl text-center mt-4">
          💖
        </div>
      </div>
    </div>
  );
};

export default ValentineMessage;
